




















































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { IProduct, ProductModel } from 'admiral-core';
import { CalendarIcon, DiscIcon, XIcon } from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FormMixin } from '@/mixins/FormMixin';
import { BModal } from 'bootstrap-vue';
import ProductForm from '@/forms/ProductForm.vue';
import { ProductApi } from '@/services/ProductApi';
import { PolicyApi } from '@/services/PolicyApi';

@Component({
  components: {
    ProductForm,
    DiscIcon,
    Multiselect,
    CalendarIcon,
    XIcon,
  },
})
export default class EditProductModal extends mixins(BaseMixin, FormMixin) {
  @Prop({ type: Object, required: false })
  selectedProduct!: IProduct;

  model = this.defaultModel();

  defaultModel(): ProductModel {
    return {
      name: this.selectedProduct?.name,
    };
  }

  @Watch('selectedProduct', { immediate: true })
  watchSelectedGoal() {
    this.model = this.defaultModel();
  }

  async ok(evt: Event) {
    evt.preventDefault();

    try {
      this.isLoading = true;
      await ProductApi.update(this.selectedProduct.id, {
        name: this.model.name,
        agency: this.agency,
      });
      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$nextTick(() => {
        (this.$refs['edit-product'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern der Aufgabe ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  async confirmDeletion() {
    try {
      await ProductApi.delete(this.selectedProduct.id!);

      (this.$refs['edit-product'] as BModal).hide();
      this.$emit('reload');

      this.$toastr.s(`Produkt ${this.model.name} erfolgreich gelöscht.`, 'Produkt gelöscht');
    } catch (e) {
      this.$toastr.e('Beim Löschen des Produkts ist etwas schief gelaufen.');
      throw e;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(
      apiErrors['nameisNotEmpty'],
      'name',
      'Bitte einen Produkt Namen eingeben angeben.',
    );
  }

  async cancel() {
    this.model = { ...this.defaultModel() };
  }
}
